
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexot0gAVFp9LdNvjhmBkmxnaUiPnD9pT8iU9RluKiPqnsMeta } from "/var/www/frontend_build/.app/pages/index.vue?macro=true";
import { default as loginYV_mxDjzUK11EWc7Jes09KZR6SMaEC45HamfZ_j1BDYMeta } from "/var/www/frontend_build/.app/pages/login.vue?macro=true";
import { default as forgothE3E7z1WCg_VmDCrX4vz4fJSeHzBTWFMXT_45cDmaqsr4Meta } from "/var/www/frontend_build/.app/pages/forgot.vue?macro=true";
import { default as verifyRqB1cFAHX_45IUhuS126c2W1p1azCuX90U8bVI1fvRF7cMeta } from "/var/www/frontend_build/.app/pages/verify.vue?macro=true";
import { default as register_KVC75s_OfCPl6E2tJvE_45c7G3WsTC1DdtsroYXu2MFMMeta } from "/var/www/frontend_build/.app/pages/register.vue?macro=true";
import { default as index7WA2JijxMKzxmvpRUB7hTfcCjkUGf_45F_45FOfQgx2BJM8Meta } from "/var/www/frontend_build/.app/pages/faq/index.vue?macro=true";
import { default as index4EU4WzKMtD_OmLnnG0ldv_45D9kq7MvEJtU4RezI1LE_8Meta } from "/var/www/frontend_build/.app/pages/home/index.vue?macro=true";
import { default as index2mi5kVmKElr1qGyxLsDJg0Ov0yl40EVZEkBH4DvaeC0Meta } from "/var/www/frontend_build/.app/pages/logs/index.vue?macro=true";
import { default as two_45factorQfu5Zk4_45ai0VyFybDU2mruZREvdKJamw1BqYSDo_sn4Meta } from "/var/www/frontend_build/.app/pages/two-factor.vue?macro=true";
import { default as new_45missiong5Zwzw0vgqeMa_45gkoQX2lDf0LbLO_45YDcwrEoHIRDkJIMeta } from "/var/www/frontend_build/.app/pages/new-mission.vue?macro=true";
import { default as indexCSwqnCKdkZwt0cviTddLiH7BBpEGTxlVlJ81kWsaqicMeta } from "/var/www/frontend_build/.app/pages/users/index.vue?macro=true";
import { default as _91id_93MoTdo8eKKEJbiO9pa2PA49DhyKuHClA4SUqYpIOkiA4Meta } from "/var/www/frontend_build/.app/pages/mission/[id].vue?macro=true";
import { default as indexRim9wMGqSnPnLRcpr40vUpuoIXIK9dpHJpNyxKQlBsIMeta } from "/var/www/frontend_build/.app/pages/offers/index.vue?macro=true";
import { default as createFirIrvDY8zomxh7t7g4J16QRG7q8DIAZOxQw9cstG3wMeta } from "/var/www/frontend_build/.app/pages/users/create.vue?macro=true";
import { default as indexmqu1rhmaoyOZNSq5LWQXP1yRFaoziU8KnMCY8TOu5F0Meta } from "/var/www/frontend_build/.app/pages/profile/index.vue?macro=true";
import { default as indexbcxRM7Cd_gJGFMHw_Nw8xgEhLSORK_45mV57t9jK7olI8Meta } from "/var/www/frontend_build/.app/pages/tickets/index.vue?macro=true";
import { default as settingsWzSdN4VNWWjNG6n4ers6uYVVceg5X4BZQQbzqSOHBeQMeta } from "/var/www/frontend_build/.app/pages/admin/settings.vue?macro=true";
import { default as indexvVfZnbeM9TY1QehoAXsX8iVK7HSgOfyLBEq5X_452Xa0UMeta } from "/var/www/frontend_build/.app/pages/forgottt/index.vue?macro=true";
import { default as indextPAlvZcucuLkk5_45XQPD8gphNOzYi9jnQeS9czoTEt6sMeta } from "/var/www/frontend_build/.app/pages/missions/index.vue?macro=true";
import { default as indexC_45JyU71tmVpdtfCHpbS1NJgO_45SfkNdgzrgKfClLu7_0Meta } from "/var/www/frontend_build/.app/pages/packages/index.vue?macro=true";
import { default as indexkNCv9nSUgFGl5f7wrgaDXOkUQoOiD4CAPBZCHXVaP2YMeta } from "/var/www/frontend_build/.app/pages/services/index.vue?macro=true";
import { default as indext2C9amHXi2lc8AChq9vKbA6hbogaqwxDsj1zLa5iFi0Meta } from "/var/www/frontend_build/.app/pages/dashboard/index.vue?macro=true";
import { default as createpV0780CitN2yc6RZM2QXPqsCwsixyw8V8gZrIiF1yKIMeta } from "/var/www/frontend_build/.app/pages/missions/create.vue?macro=true";
import { default as createQ8GZJvD2CMnex0r4fZk0Npm3BjO7nVIRCHdynEQ0e3YMeta } from "/var/www/frontend_build/.app/pages/packages/create.vue?macro=true";
import { default as create4kmQm_E4jXujwIxoZg9uUehygIKJZEAKp2TnEU_45LHB0Meta } from "/var/www/frontend_build/.app/pages/services/create.vue?macro=true";
import { default as _91id_935f5zMsXWJMrW6IOvtR1b7IC_45Q5GYFX_45h12_vitbyDw4Meta } from "/var/www/frontend_build/.app/pages/users/edit/[id].vue?macro=true";
import { default as indexO_sqSiypfHgDw3DutZncv47aIj9H1KKNIcFhcaVyIaAMeta } from "/var/www/frontend_build/.app/pages/admin/faqs/index.vue?macro=true";
import { default as new_45subscriptionLe3W2atmiyE3ZT3FXvA0kjBV2mNebqF3U_GRkA2U46sMeta } from "/var/www/frontend_build/.app/pages/new-subscription.vue?macro=true";
import { default as indexETtJFNNBTr02ZxaZaKL7DkqSwHuhmqUTZJ5E8NGajkcMeta } from "/var/www/frontend_build/.app/pages/pages/[id]/index.vue?macro=true";
import { default as indexi4SufvtPw3dct8S_4566Vf6TNVPBWH5H9oOuwDbKF_HEsMeta } from "/var/www/frontend_build/.app/pages/price/list/index.vue?macro=true";
import { default as indexQcm2doTj3uDNh0w5cG9KdNfaL1w6aP2QBeLOdZUaFtEMeta } from "/var/www/frontend_build/.app/pages/references/index.vue?macro=true";
import { default as indexRViYK9_j3d_458Rcj1qoLpjKBKXyn41zrnZjyUWcur4bsMeta } from "/var/www/frontend_build/.app/pages/tickets/me/index.vue?macro=true";
import { default as createFKMevwNG9LQP5irNKA44caI5wH_458hhol0Bp2JlTlyzwMeta } from "/var/www/frontend_build/.app/pages/admin/faqs/create.vue?macro=true";
import { default as indexuOICefhlwI2M91Mcl4_454kXYNr_ktoElpsJHBxC_45HZUIMeta } from "/var/www/frontend_build/.app/pages/admin/pages/index.vue?macro=true";
import { default as indexp4XoY21UQgyjtOpvz_45mUZ_45i8_45KZ2BdI6ZQcmSHEN5DIMeta } from "/var/www/frontend_build/.app/pages/admin/roles/index.vue?macro=true";
import { default as indexGaLF__33NZ1DAs1erGrR87PpErUyEQWJVlLiIpCyR8QMeta } from "/var/www/frontend_build/.app/pages/me/missions/index.vue?macro=true";
import { default as permission_45deniedV8syja8nM3mm_45ChRBOSOi3aWXGtLsGvCrcMnUn_45N6ZQMeta } from "/var/www/frontend_build/.app/pages/permission-denied.vue?macro=true";
import { default as create37v6hiczxGOMugqRMC5coVqhvnEfEXbOh5Y1dUywVRMMeta } from "/var/www/frontend_build/.app/pages/references/create.vue?macro=true";
import { default as _91id_93THRMi1xQOQDAwDECwv8EmBycRS6hlXeA5sgqz6aq0dcMeta } from "/var/www/frontend_build/.app/pages/tickets/edit/[id].vue?macro=true";
import { default as createsVr__AuMdkOR4kh9k_45kRa2kFxDOroYQK_45bkNl3PrpTkMeta } from "/var/www/frontend_build/.app/pages/tickets/me/create.vue?macro=true";
import { default as createX_453UbaJuKuRsHzQTwQlz4pSC0qXbgSm8aoNXSLFk4sIMeta } from "/var/www/frontend_build/.app/pages/admin/pages/create.vue?macro=true";
import { default as createNHIsMYwizfIXpD6fD6ZLRGggxDS2ycr2uM_45sCZbUBVYMeta } from "/var/www/frontend_build/.app/pages/admin/roles/create.vue?macro=true";
import { default as _91id_93gTsC5Z8OwDWa71BLyeeFlMaknHgUjpUsRN71yew31BoMeta } from "/var/www/frontend_build/.app/pages/missions/edit/[id].vue?macro=true";
import { default as _91id_93gsLkbk1xukcT_45WbcAX1mm0tMRn4dQtSbAfOXcajcHzgMeta } from "/var/www/frontend_build/.app/pages/missions/show/[id].vue?macro=true";
import { default as indexlvQFf_458DQ0ygW8Es_45DhsLnAzHuwm_CbtLjVNQunJ5hMMeta } from "/var/www/frontend_build/.app/pages/mobile/pages/index.vue?macro=true";
import { default as _91id_93gMvPk6KT8ENfcQlQXeCq25hBgtSrxdn6ocQw7_45VjoO8Meta } from "/var/www/frontend_build/.app/pages/packages/edit/[id].vue?macro=true";
import { default as _91id_93HpW1wB31erHkNvauUhHMWRS8qqTtiv4yik735aTJcyAMeta } from "/var/www/frontend_build/.app/pages/services/edit/[id].vue?macro=true";
import { default as indextoVvXuKLKivn2SmhcE6AODRvy_45IhGKTDNjfKmls_15MMeta } from "/var/www/frontend_build/.app/pages/store/orders/index.vue?macro=true";
import { default as indexpvnTG1_dM3Ms_45mwXv6vMbZrgFdkmtXLDGmmeXmBC_45o8Meta } from "/var/www/frontend_build/.app/pages/users/banned/index.vue?macro=true";
import { default as indexFjVQ5_45ohyJp46KQjOE3EzLZjYmW65khAtc_45IN74FzVEMeta } from "/var/www/frontend_build/.app/pages/users/gigcep/index.vue?macro=true";
import { default as index2kmAchSlA83rTEoEkr5ZWC_45BvIbGxqcReaGXWTTxIe4Meta } from "/var/www/frontend_build/.app/pages/contract/kvkk/index.vue?macro=true";
import { default as indexp8LcQB6k1cx7G_JBCaq8NsyXWUwliIngHY3RIbWEPu8Meta } from "/var/www/frontend_build/.app/pages/missions/[id]/index.vue?macro=true";
import { default as create_yKTJiHDWOUUXwk8b_45MC2jRZ1vKvP9Ml3IdLcnusYREMeta } from "/var/www/frontend_build/.app/pages/mobile/pages/create.vue?macro=true";
import { default as index2AkxTpYvthr_SYYsqKzDJMpo_gtDFJoGg_45Y63hWVvAEMeta } from "/var/www/frontend_build/.app/pages/payment/plans/index.vue?macro=true";
import { default as _91id_930uCQYiqzvXRBa4rVOConIu2nhdhe_45KI20DxV2mpj3ooMeta } from "/var/www/frontend_build/.app/pages/services/steps/[id].vue?macro=true";
import { default as create6wsQ6_45uhetHzq2Ghy8g8FSqYvAMv06utFWi_45_tZlmYAMeta } from "/var/www/frontend_build/.app/pages/store/orders/create.vue?macro=true";
import { default as indexV6VYmsCGGbth7xPr6KV4PljX9af43ffop0_45weuIpug8Meta } from "/var/www/frontend_build/.app/pages/subscriptions/index.vue?macro=true";
import { default as _91id_93UWlTiBQdJiKoJZgDzAHb69DI7TjOWTG6GF7bFlsg928Meta } from "/var/www/frontend_build/.app/pages/tickets/detail/[id].vue?macro=true";
import { default as _91id_93zX0E3QdLuhoPxcy4eTk0nFlwnmj3yPS5CQcl4b0kLbUMeta } from "/var/www/frontend_build/.app/pages/admin/faqs/edit/[id].vue?macro=true";
import { default as settingslt4YEFBtsGe6Z0UNGGjDH_V0NQdf3ye_45SlZeoVI8Fz4Meta } from "/var/www/frontend_build/.app/pages/admin/modal/settings.vue?macro=true";
import { default as _91id_93SIzK42fWaC4w_45Ce3DL12DdIOi9WdYg5yUNMa25NHwz8Meta } from "/var/www/frontend_build/.app/pages/missions/detail/[id].vue?macro=true";
import { default as indexAryVU5flRhui0Bc7ZIiBYAjyFlgWiy8PBv59FN2ykTwMeta } from "/var/www/frontend_build/.app/pages/order-tracking/index.vue?macro=true";
import { default as create5dd9L7mEyle32agydCTui7tj6BBXAt4vQSvs_rqs_453sMeta } from "/var/www/frontend_build/.app/pages/payment/plans/create.vue?macro=true";
import { default as _91id_93uKFe9HcaHp9JWxABERBQ8SoJGnlaXp4p5akDwz21vdUMeta } from "/var/www/frontend_build/.app/pages/references/edit/[id].vue?macro=true";
import { default as indexsB9t0EN0e8P5Ij4jRxo2KWNaNX7kQXCbB6LraMN99e4Meta } from "/var/www/frontend_build/.app/pages/admin/constants/index.vue?macro=true";
import { default as indexHzmsAjMW_4504cFWT20M_45h_45djnIXxjrbvx5h6iMzy5IpAMeta } from "/var/www/frontend_build/.app/pages/admin/contracts/index.vue?macro=true";
import { default as _91id_93ElKAExRVubqS8pV4az8COL4cARt2_KZvxGv7_45SNrVOgMeta } from "/var/www/frontend_build/.app/pages/admin/pages/edit/[id].vue?macro=true";
import { default as _91id_93CmdjpnDrjEDRX5WeYEXuG3reRJG84MAKwGU77_45crlMkMeta } from "/var/www/frontend_build/.app/pages/admin/roles/edit/[id].vue?macro=true";
import { default as indexnh0eq8ctUNsV48LM6h30U0r5KSf3ArZqs2eb87uOrjIMeta } from "/var/www/frontend_build/.app/pages/balance/history/index.vue?macro=true";
import { default as index_45vqw5tN_hHjYMfpR3JcYlEKguDErXvgTFP0JRKYxKjUMeta } from "/var/www/frontend_build/.app/pages/perfect-service/index.vue?macro=true";
import { default as indexi_45ab9NMgaPcVQJe_45B8OV_45iE_dWsypwHq_avGJle1qXAMeta } from "/var/www/frontend_build/.app/pages/reward/requests/index.vue?macro=true";
import { default as indexUP56sDqnaiWjxpVNSPtlAths53wcsaXjeOu8_31G8hgMeta } from "/var/www/frontend_build/.app/pages/social/accounts/index.vue?macro=true";
import { default as indexXAFWL95QCQ_45L_Uk_tkxnq8GZsX97ZL1NK8SKU6zCzb0Meta } from "/var/www/frontend_build/.app/pages/store/orders/me/index.vue?macro=true";
import { default as indexNqoJjhVvAaWaexREhFMtvzSYW1ghvxRflAR2VMC7f0AMeta } from "/var/www/frontend_build/.app/pages/tickets/me/[id]/index.vue?macro=true";
import { default as indexYXuXVPAUV6BJLhv3A846u_45_45sZ_siU_Kldq9MJg3_FVoMeta } from "/var/www/frontend_build/.app/pages/users/360sosyal/index.vue?macro=true";
import { default as create63vTTQzvVhsM6CYFr2U1WwR0OolXbW3bPiOK_ooODFQMeta } from "/var/www/frontend_build/.app/pages/admin/constants/create.vue?macro=true";
import { default as createu_ngb_45u2ApDm6UGx8ulIFNWuGWUejshcw93_FxQI4J8Meta } from "/var/www/frontend_build/.app/pages/admin/contracts/create.vue?macro=true";
import { default as index2ANDHluCcbG0uz18EOtS_ufg13aO66rvyzJv56z9eq8Meta } from "/var/www/frontend_build/.app/pages/admin/parameters/index.vue?macro=true";
import { default as indexoT7D9LTGVwX7MytafmaqIxISribmoXoUKNU91mNkx6cMeta } from "/var/www/frontend_build/.app/pages/balance/packages/index.vue?macro=true";
import { default as create_45backup9A58wv0KEQ55AkXH3YdiEW2RGyqzr5AB4G8RxBZsuMsMeta } from "/var/www/frontend_build/.app/pages/missions/create-backup.vue?macro=true";
import { default as indexCuVtbyF9gqJuZhKcJ0_maJ2FW5LnkJUCXcsg5zNlWfEMeta } from "/var/www/frontend_build/.app/pages/missions/reports/index.vue?macro=true";
import { default as _91id_93LkFxN6N5moMCao0i_GwgnX3VoELD91ifZANXCLt_45uKMMeta } from "/var/www/frontend_build/.app/pages/mobile/pages/edit/[id].vue?macro=true";
import { default as indexbT1IVl1nsZqUBERfXz8LPA7YtSOstb_aKZsDmSwPOacMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/index.vue?macro=true";
import { default as indexdmBIL7B3OcdfUHFAbH2RHldklb1p_ArHtBANTAJTo3AMeta } from "/var/www/frontend_build/.app/pages/payment/plans/me/index.vue?macro=true";
import { default as _91id_93WHU0Im_OZDYJEnSkON54zlBhDxAUH0AaqJlTZM3g_i4Meta } from "/var/www/frontend_build/.app/pages/payment/plans/pay/[id].vue?macro=true";
import { default as indexNQCXDiYq8btCqgv7PbRdxQ5lMhuuYb2ybm05SAkzJGIMeta } from "/var/www/frontend_build/.app/pages/reference-system/index.vue?macro=true";
import { default as create7UCbq8_DxIBO_keRIUCrWEk3wGCXQK7Ghu1fDW5a3BIMeta } from "/var/www/frontend_build/.app/pages/reward/requests/create.vue?macro=true";
import { default as index7tWmF_G0L4Xn_45cbE_2nHK9sUxr0al0gtAvKuFKw5x7AMeta } from "/var/www/frontend_build/.app/pages/service-packages/index.vue?macro=true";
import { default as _91id_93_lUa2Z2cCqU8cmmkiQa8HPv96cXX47PhdXJgRrIsYIAMeta } from "/var/www/frontend_build/.app/pages/services/steps-en/[id].vue?macro=true";
import { default as index5Vx1rjbAV4426r34fufDEn2DoI8VcR6w5_ZH0uNlA_45YMeta } from "/var/www/frontend_build/.app/pages/admin/how-to-uses/index.vue?macro=true";
import { default as createDZ7bJhCiL1Lmc5aI0T_45yTASL9NB0dtU1A2lzWz1NMQsMeta } from "/var/www/frontend_build/.app/pages/admin/parameters/create.vue?macro=true";
import { default as backupoQpQLtF3BI2l78DSPPiLN8tFG88G6GUsmA_456Lk2Aod8Meta } from "/var/www/frontend_build/.app/pages/balance/packages/backup.vue?macro=true";
import { default as indexAV9m19qvRaPEn3YMt3Sfazh7u0PZHgosinULzq2gpR4Meta } from "/var/www/frontend_build/.app/pages/bulk-service-edit/index.vue?macro=true";
import { default as index3mBXWhsgCq_45gKx_45OUxW79gQEF54AXhVtcLP06LzsN5QMeta } from "/var/www/frontend_build/.app/pages/missions/telegram/index.vue?macro=true";
import { default as createtSMLF_45Axfko632pg12w_45lOuiiG7S2DT7xARsiTqbywQMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/create.vue?macro=true";
import { default as _91id_93i5ZtiLqM4AePedeTuu6S70qO7DkAGU0aYXuhuGoaAbcMeta } from "/var/www/frontend_build/.app/pages/payment/plans/edit/[id].vue?macro=true";
import { default as index_sG8yaHzeYaRewjzD_45tKEMt61N_rTZb4UVuUf3bdscgMeta } from "/var/www/frontend_build/.app/pages/payment/plans/pay/index.vue?macro=true";
import { default as created_45UPnIVFRGg3AA8ihMMX3p738M2SnYkF_o1m7Rit_fEMeta } from "/var/www/frontend_build/.app/pages/service-packages/create.vue?macro=true";
import { default as indexydyN6QeTzMA68kt4Di6PIBR3fIaUpNjMjxVteF6zxXEMeta } from "/var/www/frontend_build/.app/pages/whatsapp/messages/index.vue?macro=true";
import { default as indexN1f7cvik7nbSP2yCF_7_Qqh884Ha9Dv_45QxFvTtB0PvAMeta } from "/var/www/frontend_build/.app/pages/admin/daily/wheels/index.vue?macro=true";
import { default as createjoL5q_u835HAMD6OpFih4ModPjHOu1eKGYmq1NoIOFIMeta } from "/var/www/frontend_build/.app/pages/admin/how-to-uses/create.vue?macro=true";
import { default as indexyZiSNlTmaVkgrcUxOi7y5GPTHcvWjtX_45AcVIsiwlbEAMeta } from "/var/www/frontend_build/.app/pages/admin/registration/index.vue?macro=true";
import { default as indexg1M6jHvZeib9FJ7_oB6Pr_453UxvNc9sFY6BooN7Kot38Meta } from "/var/www/frontend_build/.app/pages/me/missions/proofs/index.vue?macro=true";
import { default as indexyEHc3o1WkhYiCXongLNGuTL3QPwQvzNoxJZCwesgYaAMeta } from "/var/www/frontend_build/.app/pages/reward/requests/me/index.vue?macro=true";
import { default as index9hcys7Y5hDptZ0nEotBbDpxHvpW4snEXaTUO_45nC0814Meta } from "/var/www/frontend_build/.app/pages/whatsapp/instances/index.vue?macro=true";
import { default as createC4T2naFzpgNVsYHDrDL_450qOuS9NSfenvojHAO_45i1_e0Meta } from "/var/www/frontend_build/.app/pages/whatsapp/messages/create.vue?macro=true";
import { default as indexr2etPU45y8vzMqK9Uops_45Qlu9eWk89xSFDRalzKrk4cMeta } from "/var/www/frontend_build/.app/pages/admin/announcements/index.vue?macro=true";
import { default as indexZoUyYzrqMoOWjEAzbrLStGd_za_nC2_x5ogBBTl4P5wMeta } from "/var/www/frontend_build/.app/pages/admin/blocked/links/index.vue?macro=true";
import { default as _91id_93ZmOeESNdOw1i2FFyzNlNYztCK2kpQ6Yann5_FgLBjzcMeta } from "/var/www/frontend_build/.app/pages/admin/constants/edit/[id].vue?macro=true";
import { default as _91id_93al8WHBEyRPWf6UMtvwxoKZQD5kHPfgnSDDqp3PLVByEMeta } from "/var/www/frontend_build/.app/pages/admin/contracts/edit/[id].vue?macro=true";
import { default as createsogSMhBZhA3KVzIw2gbdDtGtwvcU0zoF_IYjRsRr3p0Meta } from "/var/www/frontend_build/.app/pages/admin/daily/wheels/create.vue?macro=true";
import { default as index7HBWHTMKBGQF8e6SdC5arsJK7Y9cihzlUalljD62ALMMeta } from "/var/www/frontend_build/.app/pages/admin/quick/answers/index.vue?macro=true";
import { default as index1ilfQrkDki41F27rgbI13toHmkoyePOs1UmB03bdWJsMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/me/index.vue?macro=true";
import { default as _91id_93m_45DoNpVq1WLv0ixDYf9LqW1s8W_454TtorXFxbOAVSTyUMeta } from "/var/www/frontend_build/.app/pages/perfect-service/edit/[id].vue?macro=true";
import { default as _91id_93xZnrvkZ93MzMffapnjYr9gNPofgYgQ7J87ERcWM1bpQMeta } from "/var/www/frontend_build/.app/pages/perfect-service/show/[id].vue?macro=true";
import { default as createcw_45U0I8WiFAsLLUH0CH5bbDYNrqh4ASbTFAs_AcmkbwMeta } from "/var/www/frontend_build/.app/pages/whatsapp/instances/create.vue?macro=true";
import { default as creategtKw9pFpOy8gE0MrjT4SCTKdvnVMEbsJy10uHheCxxoMeta } from "/var/www/frontend_build/.app/pages/admin/announcements/create.vue?macro=true";
import { default as createEXYHu2OXqROMB4hCQFMLhV9x2TX1f2D9l_HlnN_45v9XoMeta } from "/var/www/frontend_build/.app/pages/admin/blocked/links/create.vue?macro=true";
import { default as _91id_93LljWXwOTzTw1HW_5cJ25ciN6BTTmMdWmRgL5dDC9qSMMeta } from "/var/www/frontend_build/.app/pages/admin/parameters/edit/[id].vue?macro=true";
import { default as createNa2fwMCdvE02UoOzYdE8KjDayUT32HXiF3k4V4lqSC4Meta } from "/var/www/frontend_build/.app/pages/admin/quick/answers/create.vue?macro=true";
import { default as indexrbHIG7JoK3eZ7vlAwiTWeg00CHobafKri9deNv8pUdkMeta } from "/var/www/frontend_build/.app/pages/missions/proofs/[id]/index.vue?macro=true";
import { default as indexNsKho0gSRlujny8PqunVbCVj6jIiRjsuu3JwDcRLvAMMeta } from "/var/www/frontend_build/.app/pages/mobile/announcements/index.vue?macro=true";
import { default as _91id_93valfA0WzZeO_45lG4rfpjLfU6c1FXqkjZRhOoqZgnv52kMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/edit/[id].vue?macro=true";
import { default as createhyorGmPBv_45t04U5TUUGR1Ztvs0rugrJlS9cGtyNchHAMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/me/create.vue?macro=true";
import { default as _91id_93WaSk5Hy2Jeo6inrUHuNKeTliIebOX2Tsh6vfxzwCk_45YMeta } from "/var/www/frontend_build/.app/pages/service-packages/edit/[id].vue?macro=true";
import { default as _91id_93h7ATK4GJA_45woD23w45Hi_454UYM1NgIviZuBW0KQKTZtgMeta } from "/var/www/frontend_build/.app/pages/admin/how-to-uses/edit/[id].vue?macro=true";
import { default as createO0nx85sVVXYMI0UoxP2Sp5ON8uvR_451CFylOCyhHmd9wMeta } from "/var/www/frontend_build/.app/pages/mobile/announcements/create.vue?macro=true";
import { default as indexeaOYFJUfCF3s_WX5PKDijPMLQ6JNAyd5uFlSxTmrgkUMeta } from "/var/www/frontend_build/.app/pages/offers/offer-services/index.vue?macro=true";
import { default as index8WfzWGsYS0g2UoU6p_MQiBxwm8mskeGMfhgDr_45ycn6cMeta } from "/var/www/frontend_build/.app/pages/payment-result/failed/index.vue?macro=true";
import { default as indexucEHUzYGfUSWOA22XJ5ANU420wRMobRd1q4o4sgEv6sMeta } from "/var/www/frontend_build/.app/pages/reward-settings/items/index.vue?macro=true";
import { default as index742Iw6KZOVz5PHAcL8ZYdFPrOC_JR7hpKVEQzePhQFwMeta } from "/var/www/frontend_build/.app/pages/social/accounts/proof/index.vue?macro=true";
import { default as indexz43x4PmZSg3XsMMUsQgQuRSIGTV9lUzTO7l3T5hPHJ4Meta } from "/var/www/frontend_build/.app/pages/store/settings/groups/index.vue?macro=true";
import { default as indexLRN5hsFpvcJqVuB7JmP9fbZD_lDtvvm_45E5As6H2bBTIMeta } from "/var/www/frontend_build/.app/pages/subscription-packages/index.vue?macro=true";
import { default as indexxWxb5sM51_45rCH2_CZYtxmvT0OFB4ccc8evBJqq_Q9mwMeta } from "/var/www/frontend_build/.app/pages/users/gigcep-send-sms/index.vue?macro=true";
import { default as _91id_93HoNkSD1bxySnkkl8n62wEgPbQfKNVz0pl2j4RYLjU6wMeta } from "/var/www/frontend_build/.app/pages/whatsapp/messages/edit/[id].vue?macro=true";
import { default as _91id_93aR34vtakXKBqskM54RDmUz111_URldIfMMJjmN3etugMeta } from "/var/www/frontend_build/.app/pages/admin/daily/wheels/edit/[id].vue?macro=true";
import { default as indexpOh1G1Nu44xJDw9KO_CRwpInbWJfNr5b0kdpi5ezBc4Meta } from "/var/www/frontend_build/.app/pages/missions/past-missions/index.vue?macro=true";
import { default as create_2s_vZUuhDfwj_45NZIv_KWpxn6I3Fb0qJc_2UZoYQvLoMeta } from "/var/www/frontend_build/.app/pages/offers/offer-services/create.vue?macro=true";
import { default as indexmdLIkDMIt0NJGN_2Y4oMRksSj9H09lWlK86cw1gqyuAMeta } from "/var/www/frontend_build/.app/pages/payment-result/success/index.vue?macro=true";
import { default as createC_XoFCM_7APdkqK6hGBz4AKv2_45N4YGGI0J0_455fCQf_45IMeta } from "/var/www/frontend_build/.app/pages/reward-settings/items/create.vue?macro=true";
import { default as indexJuLwAWmy39XS5Ku_vgZNeq0tH3nQnRx6bWK7ACCs5LkMeta } from "/var/www/frontend_build/.app/pages/social/accounts/banned/index.vue?macro=true";
import { default as indexONpuY3pRi42iuvxcbU716ZZV8JFqT55cl_45Wx86FzE70Meta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/index.vue?macro=true";
import { default as createaeV_sRdxBhkdvT8CNYlshXCEagACWnEeR3nmXPbfsq8Meta } from "/var/www/frontend_build/.app/pages/store/settings/groups/create.vue?macro=true";
import { default as _91id_9369n9Mvl5EzFQHs15rsaRQS2sY1OiclIy1ylw4uFi1tgMeta } from "/var/www/frontend_build/.app/pages/tickets/detail-for-user/[id].vue?macro=true";
import { default as _91id_93S21oqNsOKex2bax4b6Un0Z0pvT_XPxP20hocWcVJk9oMeta } from "/var/www/frontend_build/.app/pages/whatsapp/instances/edit/[id].vue?macro=true";
import { default as _91id_93kE3V9HdEATghuoO7Ni0rkw40WU_7zBDwh2Tsyitz3GAMeta } from "/var/www/frontend_build/.app/pages/admin/announcements/edit/[id].vue?macro=true";
import { default as _91id_93htBMGkzTn3mOYcGvxWOcVO0CssSUYcASuqXK76wVQOUMeta } from "/var/www/frontend_build/.app/pages/admin/blocked/links/edit/[id].vue?macro=true";
import { default as _91id_93D8JAcXlu1_Wl9hCMPAGCsyHuaDmc5AynpGpcXxvRt1MMeta } from "/var/www/frontend_build/.app/pages/admin/quick/answers/edit/[id].vue?macro=true";
import { default as index4iwjH5mqTfA_45HltreFpP0oZMkHoGFM0k3dwCAdWDd6sMeta } from "/var/www/frontend_build/.app/pages/missions/proofs/me/[id]/index.vue?macro=true";
import { default as _91id_93fMRoYZ5VO9E_45L5REw4Oyqn9jl7PibxbOlQbrYmVAxUQMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/me/edit/[id].vue?macro=true";
import { default as indexQYZtZqvy08CtKIgf8pHUAT7Q1ZWNgPPuf5yHOTlw4qkMeta } from "/var/www/frontend_build/.app/pages/reward-settings/oyunfor/index.vue?macro=true";
import { default as createUddDF5NyM86UdaM2Z7EypLmPdmW_458JJ1IK0zSw5iuBAMeta } from "/var/www/frontend_build/.app/pages/social/accounts/banned/create.vue?macro=true";
import { default as indexxbp3NC1mIiYdHrI6GuNxYPl1U7U_45off0QSyeODfcxCMMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/index.vue?macro=true";
import { default as indexhtCffplvuTZQ8Q5f9Dz3_14web6_45_45FCnLCCIIrj1mW0Meta } from "/var/www/frontend_build/.app/pages/store/settings/services/index.vue?macro=true";
import { default as index7sWG3KDCI7q3TudsFvVhY6RBw08cuoGXMdaqOz_45yALsMeta } from "/var/www/frontend_build/.app/pages/admin/service/categories/index.vue?macro=true";
import { default as _91id_93OHDP06Ae2GEiLzHLdmD3gobV1cP6JJp3y74P4XWJg7UMeta } from "/var/www/frontend_build/.app/pages/mobile/announcements/edit/[id].vue?macro=true";
import { default as indexFwapb4m6NkpLWWq7ihmjVVPpVYmVvpeBRJIcJL8igpsMeta } from "/var/www/frontend_build/.app/pages/offers/integrated-offers/index.vue?macro=true";
import { default as index82iMyMIXaELwQ6spVHVwTFFcEOmgM_bFehD1ubw7IF8Meta } from "/var/www/frontend_build/.app/pages/reports/user-point-ranks/index.vue?macro=true";
import { default as create_45RpjoZr8F076apliFsJuYIclF71AN0ho5MG4ufRb89cMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/create.vue?macro=true";
import { default as createJ6oxSC5ZWFDhRTtxdfPUOxyLrs4Tn_CPx1aOWJmNMToMeta } from "/var/www/frontend_build/.app/pages/store/settings/services/create.vue?macro=true";
import { default as createQ2ne_45ka_45VpNZikkKzLFy6CQbLt9DINieizXsE0JRgJcMeta } from "/var/www/frontend_build/.app/pages/admin/service/categories/create.vue?macro=true";
import { default as index_shEDOHAcDXHNj5tOXF5OyTU4LpfjmPFk2fPwF7qUNsMeta } from "/var/www/frontend_build/.app/pages/missions/pending-approval/index.vue?macro=true";
import { default as indexTofpZWXCklgH6LR39FmU3oLWQXkp_45os5MY1yz07DELsMeta } from "/var/www/frontend_build/.app/pages/missions/tracking/me/[id]/index.vue?macro=true";
import { default as index4tieUPv_45cn_45cVmjyH6PeD0JCSobVTZNCJZkiKhES1lUMeta } from "/var/www/frontend_build/.app/pages/missions/user-with-proofs/index.vue?macro=true";
import { default as _91id_93Ng56Zc27VxLO4lIxA4fibZEl8LzoZk5R06WGnJvZmtwMeta } from "/var/www/frontend_build/.app/pages/offers/offer-services/edit/[id].vue?macro=true";
import { default as indexzSTbEdBWC7F2lt7ejZ_fHgiwaa5VK52jJi2MYjV38m0Meta } from "/var/www/frontend_build/.app/pages/reports/user-spend-report/index.vue?macro=true";
import { default as _91id_93yXGE5bWTsJvVuicTwnlFjZozcMZNZOnYswwJiZV8S6cMeta } from "/var/www/frontend_build/.app/pages/reward-settings/items/edit/[id].vue?macro=true";
import { default as indexuqRJozN5IPspdcgHNC4_D9iPn8x_45bdWwksHwSOio2ywMeta } from "/var/www/frontend_build/.app/pages/reward/requests/me/create/index.vue?macro=true";
import { default as indexE2RqZv1iSHfhRlEIZaeyNQ_rYp1ULr4gUxYWIORtS84Meta } from "/var/www/frontend_build/.app/pages/store/settings/categories/index.vue?macro=true";
import { default as _91id_9352PwajBm2Dju5tOuguUmS1_45pbpvIYIHr3SsoDRWVlsYMeta } from "/var/www/frontend_build/.app/pages/store/settings/groups/edit/[id].vue?macro=true";
import { default as indexoBlzdxk1lmxof4srho9N44hZ1ItpHKjrh3H7Zd2e_ukMeta } from "/var/www/frontend_build/.app/pages/me/missions/action/waiting/index.vue?macro=true";
import { default as _91id_934gTEdpceIwPlrKhgWC9oHgkVTHrbpfFPjX1kvsFUTq0Meta } from "/var/www/frontend_build/.app/pages/me/missions/proofs/declined/[id].vue?macro=true";
import { default as _91id_93Sm0tTYxi7A7nVreWnSgCoVKbu2bqpoMlUCx5AJzLMUIMeta } from "/var/www/frontend_build/.app/pages/me/missions/re-upload-proof/[id].vue?macro=true";
import { default as indexBfXocL1F_lHVUxKdTRSITkZMqeLQftviXXircBpDN9EMeta } from "/var/www/frontend_build/.app/pages/reward-settings/categories/index.vue?macro=true";
import { default as _91id_93ks4FW4_45fIRbhhJ4DGVWXxp4h75xIobNUX_S40EP8wKUMeta } from "/var/www/frontend_build/.app/pages/social/accounts/banned/edit/[id].vue?macro=true";
import { default as createy5jc_JWL3EIICMqzAu_458ncwbazGADM1ZsoZV_45jKgTp8Meta } from "/var/www/frontend_build/.app/pages/store/settings/categories/create.vue?macro=true";
import { default as indexwB5cMJB5ZWws5Cg_i7TKIEkmlP80x_456DZdfpI4_45CKXsMeta } from "/var/www/frontend_build/.app/pages/me/missions/action/approved/index.vue?macro=true";
import { default as indexYvYsrmHZ0Nko45mR0rkk895y09YYCoO41hPdsYkbaM4Meta } from "/var/www/frontend_build/.app/pages/me/missions/action/rejected/index.vue?macro=true";
import { default as indexCwlR6493WAq7cB7zhdZ3DmmuaEyGzRiv4jVp0lRJMUsMeta } from "/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/index.vue?macro=true";
import { default as createdDj_45et0nM9U1wrZ3aHDxhoSsldyLZn_ynejv9FiiYCYMeta } from "/var/www/frontend_build/.app/pages/reward-settings/categories/create.vue?macro=true";
import { default as _91id_93j_45vm6SpGeVQF36cRBf_458Hw1WnEbPKL9x0IwoCGA_coAMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/edit/[id].vue?macro=true";
import { default as _91id_939zzuia7yS3vJIFSa9PNvMGB5ZD2BxUV0QbWRqSfHbvoMeta } from "/var/www/frontend_build/.app/pages/store/settings/services/edit/[id].vue?macro=true";
import { default as indexE97q5SeXYfC2IHI3ykMH1WoHxUm4iOntEU3z1mfVSLIMeta } from "/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/index.vue?macro=true";
import { default as indexuRgRMbuW5jzgjN6BmQv2LZRQcFuuPPynoHp_9S0qVewMeta } from "/var/www/frontend_build/.app/pages/admin/roles/permissions/[id]/index.vue?macro=true";
import { default as _91id_93Zn4QAXjERPyLyHfPBjItX2wYckR0stP7dRtgjowPWFMMeta } from "/var/www/frontend_build/.app/pages/admin/service/categories/edit/[id].vue?macro=true";
import { default as indexGP6ApqKYXWf7or3ArJhCkIRhEuYriYo5vJXuF2yvUIoMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-users/index.vue?macro=true";
import { default as indexGRPb14elfeD1dFt4vKsNM_6fj1vwQuaE6ptSINNWTxwMeta } from "/var/www/frontend_build/.app/pages/payment/plans/payment-result/index.vue?macro=true";
import { default as indexrri1au99HMBKFCbtSoMyhTI1kf16ci_zfWfU0pNmSrkMeta } from "/var/www/frontend_build/.app/pages/reports/daily-mission-report/index.vue?macro=true";
import { default as indexa443x2EatCUs4PLP0gkpraPDEU_45nsZ_cpIWzidXnWYgMeta } from "/var/www/frontend_build/.app/pages/reports/daily-payment-report/index.vue?macro=true";
import { default as createEjNGBzCrFJ3ahLJJjK2ezy3Ct6LkvpXkHtbymmyHIMgMeta } from "/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/create.vue?macro=true";
import { default as _91id_93dwEeqsFbeqQxTaGs24GLbQq0uYvEOTWZ4ZtkWDzVYhUMeta } from "/var/www/frontend_build/.app/pages/store/settings/categories/edit/[id].vue?macro=true";
import { default as index_FC32IdwP7kIFuPnoGGey0gvFXmt1v_45PdRw_45q8cp1mAMeta } from "/var/www/frontend_build/.app/pages/information/perfect-price-logs/index.vue?macro=true";
import { default as indexJe1wNQriTFHZGpr32qWlT4UyWlly9jJRDQ3yxkehk7sMeta } from "/var/www/frontend_build/.app/pages/missions/proof-decline-request/index.vue?macro=true";
import { default as indexf0XI7NhYkTRVNPNM71QxpTb3pVTZNT7Ey3RGEzboDdgMeta } from "/var/www/frontend_build/.app/pages/missions/user-with-proofs/[id]/index.vue?macro=true";
import { default as _91id_93a29BMVJ35IX1mKhIlxLGSzjIlKHzdm3RVdsaXhFVVVoMeta } from "/var/www/frontend_build/.app/pages/reward-settings/categories/edit/[id].vue?macro=true";
import { default as indexfOFYnXt6OvqOW6NtmKmrhuF_rWSZikS_45gJYeEoxhyu8Meta } from "/var/www/frontend_build/.app/pages/reward/requests/me/create/[id]/index.vue?macro=true";
import { default as indexDQx6_459g1ezHg4_uOFCfAJIaNqVg0dk9zB5cF9vqzEMQMeta } from "/var/www/frontend_build/.app/pages/subscriptions/pending-approval/index.vue?macro=true";
import { default as indexrMk0SGKAQuIDztjrL0ErIMDn7bD1fikT_c8vMnUyiacMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/index.vue?macro=true";
import { default as indexX6G2mQxCkKHMYcUud9LStURj4JljuIqxOqnxouLe0QsMeta } from "/var/www/frontend_build/.app/pages/admin/mission-auto-approve-rules/index.vue?macro=true";
import { default as _91id_93ALxLEdf6MDMqYxWA6ntU97aGaRn2DO7gXssYUL3cj1MMeta } from "/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/edit/[id].vue?macro=true";
import { default as indexrSsFi4A3liEcziDVT5SR_IaEJbrr5p3oaBXyFe9P2jUMeta } from "/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/[id]/index.vue?macro=true";
import { default as indexLQJxNFfCximOw6kGr__RDQI7yFnWsBj2vxXv9xdF2FcMeta } from "/var/www/frontend_build/.app/pages/social/accounts/verified-control/index.vue?macro=true";
import { default as createGYAxcSfblkNAv68k5mZvf7Oh9qZJDiMbGauHnFmm_RUMeta } from "/var/www/frontend_build/.app/pages/admin/mission-auto-approve-rules/create.vue?macro=true";
import { default as indexs_45kKVGU3ZvM3r0fy1l7SiSc4EJmURmsA46ac0SrTeKQMeta } from "/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/index.vue?macro=true";
import { default as index0C5wAzTv2G5NTAza5L_1sm6DTalygJ_fjQobwQ8Tm2oMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-users/[id]/index.vue?macro=true";
import { default as createUNgKiYnhkwHMgvyy88nGmOJQd4IHztMEa1JCwFaKMdMMeta } from "/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/create.vue?macro=true";
import { default as indexiSgk_45qEpy_45BNBEz6cmeVRwUkIQybF9ekYo_7Dag7htAMeta } from "/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/index.vue?macro=true";
import { default as indexoMJ6_45gcmOpRoILZg15mKiD9Xhq2_p5pn2_9rYhBYOewMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/index.vue?macro=true";
import { default as indexnrfutMd_twSRBTmRxZlxmuBJqZ1J1F3VCRSqaA43a7YMeta } from "/var/www/frontend_build/.app/pages/missions/proof-decline-request/[id]/index.vue?macro=true";
import { default as _91id_935IyqEWsQ8_45naH3a2jtkL_45uHGmZx3S6DViZLJ74vxMxcMeta } from "/var/www/frontend_build/.app/pages/admin/mission-auto-approve-rules/edit/[id].vue?macro=true";
import { default as index6q_45yZ2POD51cK6gHy9hS8smz6nxcXtxFLIiHHsUex0oMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/[id]/index.vue?macro=true";
import { default as indexO0JbS7xewchrfkHwlr_45hpF_45_GTJslMD60KLvnzyPcMoMeta } from "/var/www/frontend_build/.app/pages/contract/gizlilik-ve-cerez-politikasi/index.vue?macro=true";
import { default as index2wxLhSGxxpxeVDsVogu27T5iKIBysLtwcJT2W3bp6cUMeta } from "/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/[id]/index.vue?macro=true";
import { default as indexCjsTNuMAP6DRvshLJoI2KspboYNZlmuvWC4psXAFzoAMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/[id]/index.vue?macro=true";
import { default as _91rule_id_93uTYr0XB8uNCKgiMYmqz3NuUvd0KmF_h_iXSgQKmWanoMeta } from "/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/edit/[rule_id].vue?macro=true";
import { default as indexTeXaZCd9snxOt1aLtGdGZXCtCUqYrMZStiqno4rcGEwMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/index.vue?macro=true";
import { default as index1TU6NMq73VcbOaKrehS5Vp4BSB1O692_45qi60LekgQ8cMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/index.vue?macro=true";
import { default as createCwTjnlk4z7DccVgse05YQpY7z4SCoho7oTDHBD3LShsMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/create.vue?macro=true";
import { default as _91id_93quKEpk1a1AymoWv1iqfvbhlqjSSXR_45v0Z7SSpa75zVEMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/edit/[id].vue?macro=true";
import { default as indexxdX_45dX47eHEDF_TiQpu7UJc7xhKDXBzzLHz8sO3mOrYMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_group_id]/index.vue?macro=true";
import { default as indexOrUzLKUIorM1RVdnn8AN9MhzqBgwhXLxGagkHRyQhSkMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_service_id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexot0gAVFp9LdNvjhmBkmxnaUiPnD9pT8iU9RluKiPqnsMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginYV_mxDjzUK11EWc7Jes09KZR6SMaEC45HamfZ_j1BDYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/login.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    meta: { ...(forgothE3E7z1WCg_VmDCrX4vz4fJSeHzBTWFMXT_45cDmaqsr4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/forgot.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: { ...(verifyRqB1cFAHX_45IUhuS126c2W1p1azCuX90U8bVI1fvRF7cMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/verify.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(register_KVC75s_OfCPl6E2tJvE_45c7G3WsTC1DdtsroYXu2MFMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/register.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: { ...(index7WA2JijxMKzxmvpRUB7hTfcCjkUGf_45F_45FOfQgx2BJM8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/faq/index.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: { ...(index4EU4WzKMtD_OmLnnG0ldv_45D9kq7MvEJtU4RezI1LE_8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/home/index.vue")
  },
  {
    name: "logs",
    path: "/logs",
    meta: { ...(index2mi5kVmKElr1qGyxLsDJg0Ov0yl40EVZEkBH4DvaeC0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/logs/index.vue")
  },
  {
    name: "two-factor",
    path: "/two-factor",
    meta: two_45factorQfu5Zk4_45ai0VyFybDU2mruZREvdKJamw1BqYSDo_sn4Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/two-factor.vue")
  },
  {
    name: "new-mission",
    path: "/new-mission",
    meta: new_45missiong5Zwzw0vgqeMa_45gkoQX2lDf0LbLO_45YDcwrEoHIRDkJIMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/new-mission.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(indexCSwqnCKdkZwt0cviTddLiH7BBpEGTxlVlJ81kWsaqicMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/index.vue")
  },
  {
    name: "mission-id",
    path: "/mission/:id()",
    meta: { ...(_91id_93MoTdo8eKKEJbiO9pa2PA49DhyKuHClA4SUqYpIOkiA4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mission/[id].vue")
  },
  {
    name: "offers",
    path: "/offers",
    meta: { ...(indexRim9wMGqSnPnLRcpr40vUpuoIXIK9dpHJpNyxKQlBsIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/offers/index.vue")
  },
  {
    name: "users-create",
    path: "/users/create",
    meta: { ...(createFirIrvDY8zomxh7t7g4J16QRG7q8DIAZOxQw9cstG3wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/create.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(indexmqu1rhmaoyOZNSq5LWQXP1yRFaoziU8KnMCY8TOu5F0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/profile/index.vue")
  },
  {
    name: "tickets",
    path: "/tickets",
    meta: { ...(indexbcxRM7Cd_gJGFMHw_Nw8xgEhLSORK_45mV57t9jK7olI8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/index.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: { ...(settingsWzSdN4VNWWjNG6n4ers6uYVVceg5X4BZQQbzqSOHBeQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/settings.vue")
  },
  {
    name: "forgottt",
    path: "/forgottt",
    meta: { ...(indexvVfZnbeM9TY1QehoAXsX8iVK7HSgOfyLBEq5X_452Xa0UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/forgottt/index.vue")
  },
  {
    name: "missions",
    path: "/missions",
    meta: { ...(indextPAlvZcucuLkk5_45XQPD8gphNOzYi9jnQeS9czoTEt6sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/index.vue")
  },
  {
    name: "packages",
    path: "/packages",
    meta: { ...(indexC_45JyU71tmVpdtfCHpbS1NJgO_45SfkNdgzrgKfClLu7_0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/packages/index.vue")
  },
  {
    name: "services",
    path: "/services",
    meta: { ...(indexkNCv9nSUgFGl5f7wrgaDXOkUQoOiD4CAPBZCHXVaP2YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/services/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indext2C9amHXi2lc8AChq9vKbA6hbogaqwxDsj1zLa5iFi0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/dashboard/index.vue")
  },
  {
    name: "missions-create",
    path: "/missions/create",
    meta: { ...(createpV0780CitN2yc6RZM2QXPqsCwsixyw8V8gZrIiF1yKIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/create.vue")
  },
  {
    name: "packages-create",
    path: "/packages/create",
    meta: { ...(createQ8GZJvD2CMnex0r4fZk0Npm3BjO7nVIRCHdynEQ0e3YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/packages/create.vue")
  },
  {
    name: "services-create",
    path: "/services/create",
    meta: { ...(create4kmQm_E4jXujwIxoZg9uUehygIKJZEAKp2TnEU_45LHB0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/services/create.vue")
  },
  {
    name: "users-edit-id",
    path: "/users/edit/:id()",
    meta: { ...(_91id_935f5zMsXWJMrW6IOvtR1b7IC_45Q5GYFX_45h12_vitbyDw4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/edit/[id].vue")
  },
  {
    name: "admin-faqs",
    path: "/admin/faqs",
    meta: { ...(indexO_sqSiypfHgDw3DutZncv47aIj9H1KKNIcFhcaVyIaAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/faqs/index.vue")
  },
  {
    name: "new-subscription",
    path: "/new-subscription",
    meta: new_45subscriptionLe3W2atmiyE3ZT3FXvA0kjBV2mNebqF3U_GRkA2U46sMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/new-subscription.vue")
  },
  {
    name: "pages-id",
    path: "/pages/:id()",
    meta: indexETtJFNNBTr02ZxaZaKL7DkqSwHuhmqUTZJ5E8NGajkcMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/pages/[id]/index.vue")
  },
  {
    name: "price-list",
    path: "/price/list",
    meta: { ...(indexi4SufvtPw3dct8S_4566Vf6TNVPBWH5H9oOuwDbKF_HEsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/price/list/index.vue")
  },
  {
    name: "references",
    path: "/references",
    meta: { ...(indexQcm2doTj3uDNh0w5cG9KdNfaL1w6aP2QBeLOdZUaFtEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/references/index.vue")
  },
  {
    name: "tickets-me",
    path: "/tickets/me",
    meta: { ...(indexRViYK9_j3d_458Rcj1qoLpjKBKXyn41zrnZjyUWcur4bsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/me/index.vue")
  },
  {
    name: "admin-faqs-create",
    path: "/admin/faqs/create",
    meta: { ...(createFKMevwNG9LQP5irNKA44caI5wH_458hhol0Bp2JlTlyzwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/faqs/create.vue")
  },
  {
    name: "admin-pages",
    path: "/admin/pages",
    meta: { ...(indexuOICefhlwI2M91Mcl4_454kXYNr_ktoElpsJHBxC_45HZUIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/pages/index.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: { ...(indexp4XoY21UQgyjtOpvz_45mUZ_45i8_45KZ2BdI6ZQcmSHEN5DIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/index.vue")
  },
  {
    name: "me-missions",
    path: "/me/missions",
    meta: { ...(indexGaLF__33NZ1DAs1erGrR87PpErUyEQWJVlLiIpCyR8QMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/index.vue")
  },
  {
    name: "permission-denied",
    path: "/permission-denied",
    meta: { ...(permission_45deniedV8syja8nM3mm_45ChRBOSOi3aWXGtLsGvCrcMnUn_45N6ZQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/permission-denied.vue")
  },
  {
    name: "references-create",
    path: "/references/create",
    meta: { ...(create37v6hiczxGOMugqRMC5coVqhvnEfEXbOh5Y1dUywVRMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/references/create.vue")
  },
  {
    name: "tickets-edit-id",
    path: "/tickets/edit/:id()",
    meta: { ...(_91id_93THRMi1xQOQDAwDECwv8EmBycRS6hlXeA5sgqz6aq0dcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/edit/[id].vue")
  },
  {
    name: "tickets-me-create",
    path: "/tickets/me/create",
    meta: { ...(createsVr__AuMdkOR4kh9k_45kRa2kFxDOroYQK_45bkNl3PrpTkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/me/create.vue")
  },
  {
    name: "admin-pages-create",
    path: "/admin/pages/create",
    meta: { ...(createX_453UbaJuKuRsHzQTwQlz4pSC0qXbgSm8aoNXSLFk4sIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/pages/create.vue")
  },
  {
    name: "admin-roles-create",
    path: "/admin/roles/create",
    meta: { ...(createNHIsMYwizfIXpD6fD6ZLRGggxDS2ycr2uM_45sCZbUBVYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/create.vue")
  },
  {
    name: "missions-edit-id",
    path: "/missions/edit/:id()",
    meta: { ...(_91id_93gTsC5Z8OwDWa71BLyeeFlMaknHgUjpUsRN71yew31BoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/edit/[id].vue")
  },
  {
    name: "missions-show-id",
    path: "/missions/show/:id()",
    meta: { ...(_91id_93gsLkbk1xukcT_45WbcAX1mm0tMRn4dQtSbAfOXcajcHzgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/show/[id].vue")
  },
  {
    name: "mobile-pages",
    path: "/mobile/pages",
    meta: { ...(indexlvQFf_458DQ0ygW8Es_45DhsLnAzHuwm_CbtLjVNQunJ5hMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mobile/pages/index.vue")
  },
  {
    name: "packages-edit-id",
    path: "/packages/edit/:id()",
    meta: { ...(_91id_93gMvPk6KT8ENfcQlQXeCq25hBgtSrxdn6ocQw7_45VjoO8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/packages/edit/[id].vue")
  },
  {
    name: "services-edit-id",
    path: "/services/edit/:id()",
    meta: { ...(_91id_93HpW1wB31erHkNvauUhHMWRS8qqTtiv4yik735aTJcyAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/services/edit/[id].vue")
  },
  {
    name: "store-orders",
    path: "/store/orders",
    meta: { ...(indextoVvXuKLKivn2SmhcE6AODRvy_45IhGKTDNjfKmls_15MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/index.vue")
  },
  {
    name: "users-banned",
    path: "/users/banned",
    meta: { ...(indexpvnTG1_dM3Ms_45mwXv6vMbZrgFdkmtXLDGmmeXmBC_45o8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/banned/index.vue")
  },
  {
    name: "users-gigcep",
    path: "/users/gigcep",
    meta: { ...(indexFjVQ5_45ohyJp46KQjOE3EzLZjYmW65khAtc_45IN74FzVEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/gigcep/index.vue")
  },
  {
    name: "contract-kvkk",
    path: "/contract/kvkk",
    meta: index2kmAchSlA83rTEoEkr5ZWC_45BvIbGxqcReaGXWTTxIe4Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/contract/kvkk/index.vue")
  },
  {
    name: "missions-id",
    path: "/missions/:id()",
    meta: { ...(indexp8LcQB6k1cx7G_JBCaq8NsyXWUwliIngHY3RIbWEPu8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/[id]/index.vue")
  },
  {
    name: "mobile-pages-create",
    path: "/mobile/pages/create",
    meta: { ...(create_yKTJiHDWOUUXwk8b_45MC2jRZ1vKvP9Ml3IdLcnusYREMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mobile/pages/create.vue")
  },
  {
    name: "payment-plans",
    path: "/payment/plans",
    meta: { ...(index2AkxTpYvthr_SYYsqKzDJMpo_gtDFJoGg_45Y63hWVvAEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/index.vue")
  },
  {
    name: "services-steps-id",
    path: "/services/steps/:id()",
    meta: { ...(_91id_930uCQYiqzvXRBa4rVOConIu2nhdhe_45KI20DxV2mpj3ooMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/services/steps/[id].vue")
  },
  {
    name: "store-orders-create",
    path: "/store/orders/create",
    meta: { ...(create6wsQ6_45uhetHzq2Ghy8g8FSqYvAMv06utFWi_45_tZlmYAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/create.vue")
  },
  {
    name: "subscriptions",
    path: "/subscriptions",
    meta: { ...(indexV6VYmsCGGbth7xPr6KV4PljX9af43ffop0_45weuIpug8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/subscriptions/index.vue")
  },
  {
    name: "tickets-detail-id",
    path: "/tickets/detail/:id()",
    meta: { ...(_91id_93UWlTiBQdJiKoJZgDzAHb69DI7TjOWTG6GF7bFlsg928Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/detail/[id].vue")
  },
  {
    name: "admin-faqs-edit-id",
    path: "/admin/faqs/edit/:id()",
    meta: { ...(_91id_93zX0E3QdLuhoPxcy4eTk0nFlwnmj3yPS5CQcl4b0kLbUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/faqs/edit/[id].vue")
  },
  {
    name: "admin-modal-settings",
    path: "/admin/modal/settings",
    meta: { ...(settingslt4YEFBtsGe6Z0UNGGjDH_V0NQdf3ye_45SlZeoVI8Fz4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/modal/settings.vue")
  },
  {
    name: "missions-detail-id",
    path: "/missions/detail/:id()",
    meta: { ...(_91id_93SIzK42fWaC4w_45Ce3DL12DdIOi9WdYg5yUNMa25NHwz8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/detail/[id].vue")
  },
  {
    name: "order-tracking",
    path: "/order-tracking",
    meta: { ...(indexAryVU5flRhui0Bc7ZIiBYAjyFlgWiy8PBv59FN2ykTwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/order-tracking/index.vue")
  },
  {
    name: "payment-plans-create",
    path: "/payment/plans/create",
    meta: { ...(create5dd9L7mEyle32agydCTui7tj6BBXAt4vQSvs_rqs_453sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/create.vue")
  },
  {
    name: "references-edit-id",
    path: "/references/edit/:id()",
    meta: { ...(_91id_93uKFe9HcaHp9JWxABERBQ8SoJGnlaXp4p5akDwz21vdUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/references/edit/[id].vue")
  },
  {
    name: "admin-constants",
    path: "/admin/constants",
    meta: { ...(indexsB9t0EN0e8P5Ij4jRxo2KWNaNX7kQXCbB6LraMN99e4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/constants/index.vue")
  },
  {
    name: "admin-contracts",
    path: "/admin/contracts",
    meta: { ...(indexHzmsAjMW_4504cFWT20M_45h_45djnIXxjrbvx5h6iMzy5IpAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/contracts/index.vue")
  },
  {
    name: "admin-pages-edit-id",
    path: "/admin/pages/edit/:id()",
    meta: { ...(_91id_93ElKAExRVubqS8pV4az8COL4cARt2_KZvxGv7_45SNrVOgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/pages/edit/[id].vue")
  },
  {
    name: "admin-roles-edit-id",
    path: "/admin/roles/edit/:id()",
    meta: { ...(_91id_93CmdjpnDrjEDRX5WeYEXuG3reRJG84MAKwGU77_45crlMkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/edit/[id].vue")
  },
  {
    name: "balance-history",
    path: "/balance/history",
    meta: { ...(indexnh0eq8ctUNsV48LM6h30U0r5KSf3ArZqs2eb87uOrjIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/balance/history/index.vue")
  },
  {
    name: "perfect-service",
    path: "/perfect-service",
    meta: { ...(index_45vqw5tN_hHjYMfpR3JcYlEKguDErXvgTFP0JRKYxKjUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/perfect-service/index.vue")
  },
  {
    name: "reward-requests",
    path: "/reward/requests",
    meta: { ...(indexi_45ab9NMgaPcVQJe_45B8OV_45iE_dWsypwHq_avGJle1qXAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/index.vue")
  },
  {
    name: "social-accounts",
    path: "/social/accounts",
    meta: { ...(indexUP56sDqnaiWjxpVNSPtlAths53wcsaXjeOu8_31G8hgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/index.vue")
  },
  {
    name: "store-orders-me",
    path: "/store/orders/me",
    meta: { ...(indexXAFWL95QCQ_45L_Uk_tkxnq8GZsX97ZL1NK8SKU6zCzb0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/index.vue")
  },
  {
    name: "tickets-me-id",
    path: "/tickets/me/:id()",
    meta: { ...(indexNqoJjhVvAaWaexREhFMtvzSYW1ghvxRflAR2VMC7f0AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/me/[id]/index.vue")
  },
  {
    name: "users-360sosyal",
    path: "/users/360sosyal",
    meta: { ...(indexYXuXVPAUV6BJLhv3A846u_45_45sZ_siU_Kldq9MJg3_FVoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/360sosyal/index.vue")
  },
  {
    name: "admin-constants-create",
    path: "/admin/constants/create",
    meta: { ...(create63vTTQzvVhsM6CYFr2U1WwR0OolXbW3bPiOK_ooODFQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/constants/create.vue")
  },
  {
    name: "admin-contracts-create",
    path: "/admin/contracts/create",
    meta: { ...(createu_ngb_45u2ApDm6UGx8ulIFNWuGWUejshcw93_FxQI4J8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/contracts/create.vue")
  },
  {
    name: "admin-parameters",
    path: "/admin/parameters",
    meta: { ...(index2ANDHluCcbG0uz18EOtS_ufg13aO66rvyzJv56z9eq8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameters/index.vue")
  },
  {
    name: "balance-packages",
    path: "/balance/packages",
    meta: { ...(indexoT7D9LTGVwX7MytafmaqIxISribmoXoUKNU91mNkx6cMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/balance/packages/index.vue")
  },
  {
    name: "missions-create-backup",
    path: "/missions/create-backup",
    meta: { ...(create_45backup9A58wv0KEQ55AkXH3YdiEW2RGyqzr5AB4G8RxBZsuMsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/create-backup.vue")
  },
  {
    name: "missions-reports",
    path: "/missions/reports",
    meta: { ...(indexCuVtbyF9gqJuZhKcJ0_maJ2FW5LnkJUCXcsg5zNlWfEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/reports/index.vue")
  },
  {
    name: "mobile-pages-edit-id",
    path: "/mobile/pages/edit/:id()",
    meta: { ...(_91id_93LkFxN6N5moMCao0i_GwgnX3VoELD91ifZANXCLt_45uKMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mobile/pages/edit/[id].vue")
  },
  {
    name: "payment-accounts",
    path: "/payment/accounts",
    meta: { ...(indexbT1IVl1nsZqUBERfXz8LPA7YtSOstb_aKZsDmSwPOacMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/index.vue")
  },
  {
    name: "payment-plans-me",
    path: "/payment/plans/me",
    meta: { ...(indexdmBIL7B3OcdfUHFAbH2RHldklb1p_ArHtBANTAJTo3AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/me/index.vue")
  },
  {
    name: "payment-plans-pay-id",
    path: "/payment/plans/pay/:id()",
    meta: { ...(_91id_93WHU0Im_OZDYJEnSkON54zlBhDxAUH0AaqJlTZM3g_i4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/pay/[id].vue")
  },
  {
    name: "reference-system",
    path: "/reference-system",
    meta: { ...(indexNQCXDiYq8btCqgv7PbRdxQ5lMhuuYb2ybm05SAkzJGIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reference-system/index.vue")
  },
  {
    name: "reward-requests-create",
    path: "/reward/requests/create",
    meta: { ...(create7UCbq8_DxIBO_keRIUCrWEk3wGCXQK7Ghu1fDW5a3BIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/create.vue")
  },
  {
    name: "service-packages",
    path: "/service-packages",
    meta: { ...(index7tWmF_G0L4Xn_45cbE_2nHK9sUxr0al0gtAvKuFKw5x7AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/service-packages/index.vue")
  },
  {
    name: "services-steps-en-id",
    path: "/services/steps-en/:id()",
    meta: { ...(_91id_93_lUa2Z2cCqU8cmmkiQa8HPv96cXX47PhdXJgRrIsYIAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/services/steps-en/[id].vue")
  },
  {
    name: "admin-how-to-uses",
    path: "/admin/how-to-uses",
    meta: { ...(index5Vx1rjbAV4426r34fufDEn2DoI8VcR6w5_ZH0uNlA_45YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/how-to-uses/index.vue")
  },
  {
    name: "admin-parameters-create",
    path: "/admin/parameters/create",
    meta: { ...(createDZ7bJhCiL1Lmc5aI0T_45yTASL9NB0dtU1A2lzWz1NMQsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameters/create.vue")
  },
  {
    name: "balance-packages-backup",
    path: "/balance/packages/backup",
    meta: { ...(backupoQpQLtF3BI2l78DSPPiLN8tFG88G6GUsmA_456Lk2Aod8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/balance/packages/backup.vue")
  },
  {
    name: "bulk-service-edit",
    path: "/bulk-service-edit",
    meta: { ...(indexAV9m19qvRaPEn3YMt3Sfazh7u0PZHgosinULzq2gpR4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/bulk-service-edit/index.vue")
  },
  {
    name: "missions-telegram",
    path: "/missions/telegram",
    meta: { ...(index3mBXWhsgCq_45gKx_45OUxW79gQEF54AXhVtcLP06LzsN5QMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/telegram/index.vue")
  },
  {
    name: "payment-accounts-create",
    path: "/payment/accounts/create",
    meta: { ...(createtSMLF_45Axfko632pg12w_45lOuiiG7S2DT7xARsiTqbywQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/create.vue")
  },
  {
    name: "payment-plans-edit-id",
    path: "/payment/plans/edit/:id()",
    meta: { ...(_91id_93i5ZtiLqM4AePedeTuu6S70qO7DkAGU0aYXuhuGoaAbcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/edit/[id].vue")
  },
  {
    name: "payment-plans-pay",
    path: "/payment/plans/pay",
    meta: { ...(index_sG8yaHzeYaRewjzD_45tKEMt61N_rTZb4UVuUf3bdscgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/pay/index.vue")
  },
  {
    name: "service-packages-create",
    path: "/service-packages/create",
    meta: { ...(created_45UPnIVFRGg3AA8ihMMX3p738M2SnYkF_o1m7Rit_fEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/service-packages/create.vue")
  },
  {
    name: "whatsapp-messages",
    path: "/whatsapp/messages",
    meta: { ...(indexydyN6QeTzMA68kt4Di6PIBR3fIaUpNjMjxVteF6zxXEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/whatsapp/messages/index.vue")
  },
  {
    name: "admin-daily-wheels",
    path: "/admin/daily/wheels",
    meta: { ...(indexN1f7cvik7nbSP2yCF_7_Qqh884Ha9Dv_45QxFvTtB0PvAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/daily/wheels/index.vue")
  },
  {
    name: "admin-how-to-uses-create",
    path: "/admin/how-to-uses/create",
    meta: { ...(createjoL5q_u835HAMD6OpFih4ModPjHOu1eKGYmq1NoIOFIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/how-to-uses/create.vue")
  },
  {
    name: "admin-registration",
    path: "/admin/registration",
    meta: { ...(indexyZiSNlTmaVkgrcUxOi7y5GPTHcvWjtX_45AcVIsiwlbEAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/registration/index.vue")
  },
  {
    name: "me-missions-proofs",
    path: "/me/missions/proofs",
    meta: { ...(indexg1M6jHvZeib9FJ7_oB6Pr_453UxvNc9sFY6BooN7Kot38Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proofs/index.vue")
  },
  {
    name: "reward-requests-me",
    path: "/reward/requests/me",
    meta: { ...(indexyEHc3o1WkhYiCXongLNGuTL3QPwQvzNoxJZCwesgYaAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/me/index.vue")
  },
  {
    name: "whatsapp-instances",
    path: "/whatsapp/instances",
    meta: { ...(index9hcys7Y5hDptZ0nEotBbDpxHvpW4snEXaTUO_45nC0814Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/whatsapp/instances/index.vue")
  },
  {
    name: "whatsapp-messages-create",
    path: "/whatsapp/messages/create",
    meta: { ...(createC4T2naFzpgNVsYHDrDL_450qOuS9NSfenvojHAO_45i1_e0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/whatsapp/messages/create.vue")
  },
  {
    name: "admin-announcements",
    path: "/admin/announcements",
    meta: { ...(indexr2etPU45y8vzMqK9Uops_45Qlu9eWk89xSFDRalzKrk4cMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/announcements/index.vue")
  },
  {
    name: "admin-blocked-links",
    path: "/admin/blocked/links",
    meta: { ...(indexZoUyYzrqMoOWjEAzbrLStGd_za_nC2_x5ogBBTl4P5wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/blocked/links/index.vue")
  },
  {
    name: "admin-constants-edit-id",
    path: "/admin/constants/edit/:id()",
    meta: { ...(_91id_93ZmOeESNdOw1i2FFyzNlNYztCK2kpQ6Yann5_FgLBjzcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/constants/edit/[id].vue")
  },
  {
    name: "admin-contracts-edit-id",
    path: "/admin/contracts/edit/:id()",
    meta: { ...(_91id_93al8WHBEyRPWf6UMtvwxoKZQD5kHPfgnSDDqp3PLVByEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/contracts/edit/[id].vue")
  },
  {
    name: "admin-daily-wheels-create",
    path: "/admin/daily/wheels/create",
    meta: { ...(createsogSMhBZhA3KVzIw2gbdDtGtwvcU0zoF_IYjRsRr3p0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/daily/wheels/create.vue")
  },
  {
    name: "admin-quick-answers",
    path: "/admin/quick/answers",
    meta: { ...(index7HBWHTMKBGQF8e6SdC5arsJK7Y9cihzlUalljD62ALMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/quick/answers/index.vue")
  },
  {
    name: "payment-accounts-me",
    path: "/payment/accounts/me",
    meta: { ...(index1ilfQrkDki41F27rgbI13toHmkoyePOs1UmB03bdWJsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/me/index.vue")
  },
  {
    name: "perfect-service-edit-id",
    path: "/perfect-service/edit/:id()",
    meta: { ...(_91id_93m_45DoNpVq1WLv0ixDYf9LqW1s8W_454TtorXFxbOAVSTyUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/perfect-service/edit/[id].vue")
  },
  {
    name: "perfect-service-show-id",
    path: "/perfect-service/show/:id()",
    meta: { ...(_91id_93xZnrvkZ93MzMffapnjYr9gNPofgYgQ7J87ERcWM1bpQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/perfect-service/show/[id].vue")
  },
  {
    name: "whatsapp-instances-create",
    path: "/whatsapp/instances/create",
    meta: { ...(createcw_45U0I8WiFAsLLUH0CH5bbDYNrqh4ASbTFAs_AcmkbwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/whatsapp/instances/create.vue")
  },
  {
    name: "admin-announcements-create",
    path: "/admin/announcements/create",
    meta: { ...(creategtKw9pFpOy8gE0MrjT4SCTKdvnVMEbsJy10uHheCxxoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/announcements/create.vue")
  },
  {
    name: "admin-blocked-links-create",
    path: "/admin/blocked/links/create",
    meta: { ...(createEXYHu2OXqROMB4hCQFMLhV9x2TX1f2D9l_HlnN_45v9XoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/blocked/links/create.vue")
  },
  {
    name: "admin-parameters-edit-id",
    path: "/admin/parameters/edit/:id()",
    meta: { ...(_91id_93LljWXwOTzTw1HW_5cJ25ciN6BTTmMdWmRgL5dDC9qSMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameters/edit/[id].vue")
  },
  {
    name: "admin-quick-answers-create",
    path: "/admin/quick/answers/create",
    meta: { ...(createNa2fwMCdvE02UoOzYdE8KjDayUT32HXiF3k4V4lqSC4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/quick/answers/create.vue")
  },
  {
    name: "missions-proofs-id",
    path: "/missions/proofs/:id()",
    meta: { ...(indexrbHIG7JoK3eZ7vlAwiTWeg00CHobafKri9deNv8pUdkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proofs/[id]/index.vue")
  },
  {
    name: "mobile-announcements",
    path: "/mobile/announcements",
    meta: { ...(indexNsKho0gSRlujny8PqunVbCVj6jIiRjsuu3JwDcRLvAMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mobile/announcements/index.vue")
  },
  {
    name: "payment-accounts-edit-id",
    path: "/payment/accounts/edit/:id()",
    meta: { ...(_91id_93valfA0WzZeO_45lG4rfpjLfU6c1FXqkjZRhOoqZgnv52kMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/edit/[id].vue")
  },
  {
    name: "payment-accounts-me-create",
    path: "/payment/accounts/me/create",
    meta: { ...(createhyorGmPBv_45t04U5TUUGR1Ztvs0rugrJlS9cGtyNchHAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/me/create.vue")
  },
  {
    name: "service-packages-edit-id",
    path: "/service-packages/edit/:id()",
    meta: { ...(_91id_93WaSk5Hy2Jeo6inrUHuNKeTliIebOX2Tsh6vfxzwCk_45YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/service-packages/edit/[id].vue")
  },
  {
    name: "admin-how-to-uses-edit-id",
    path: "/admin/how-to-uses/edit/:id()",
    meta: { ...(_91id_93h7ATK4GJA_45woD23w45Hi_454UYM1NgIviZuBW0KQKTZtgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/how-to-uses/edit/[id].vue")
  },
  {
    name: "mobile-announcements-create",
    path: "/mobile/announcements/create",
    meta: { ...(createO0nx85sVVXYMI0UoxP2Sp5ON8uvR_451CFylOCyhHmd9wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mobile/announcements/create.vue")
  },
  {
    name: "offers-offer-services",
    path: "/offers/offer-services",
    meta: { ...(indexeaOYFJUfCF3s_WX5PKDijPMLQ6JNAyd5uFlSxTmrgkUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/offers/offer-services/index.vue")
  },
  {
    name: "payment-result-failed",
    path: "/payment-result/failed",
    meta: { ...(index8WfzWGsYS0g2UoU6p_MQiBxwm8mskeGMfhgDr_45ycn6cMeta || {}), ...{"middleware":[]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment-result/failed/index.vue")
  },
  {
    name: "reward-settings-items",
    path: "/reward-settings/items",
    meta: { ...(indexucEHUzYGfUSWOA22XJ5ANU420wRMobRd1q4o4sgEv6sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/items/index.vue")
  },
  {
    name: "social-accounts-proof",
    path: "/social/accounts/proof",
    meta: { ...(index742Iw6KZOVz5PHAcL8ZYdFPrOC_JR7hpKVEQzePhQFwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/proof/index.vue")
  },
  {
    name: "store-settings-groups",
    path: "/store/settings/groups",
    meta: { ...(indexz43x4PmZSg3XsMMUsQgQuRSIGTV9lUzTO7l3T5hPHJ4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/groups/index.vue")
  },
  {
    name: "subscription-packages",
    path: "/subscription-packages",
    meta: { ...(indexLRN5hsFpvcJqVuB7JmP9fbZD_lDtvvm_45E5As6H2bBTIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/subscription-packages/index.vue")
  },
  {
    name: "users-gigcep-send-sms",
    path: "/users/gigcep-send-sms",
    meta: { ...(indexxWxb5sM51_45rCH2_CZYtxmvT0OFB4ccc8evBJqq_Q9mwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/users/gigcep-send-sms/index.vue")
  },
  {
    name: "whatsapp-messages-edit-id",
    path: "/whatsapp/messages/edit/:id()",
    meta: { ...(_91id_93HoNkSD1bxySnkkl8n62wEgPbQfKNVz0pl2j4RYLjU6wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/whatsapp/messages/edit/[id].vue")
  },
  {
    name: "admin-daily-wheels-edit-id",
    path: "/admin/daily/wheels/edit/:id()",
    meta: { ...(_91id_93aR34vtakXKBqskM54RDmUz111_URldIfMMJjmN3etugMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/daily/wheels/edit/[id].vue")
  },
  {
    name: "missions-past-missions",
    path: "/missions/past-missions",
    meta: { ...(indexpOh1G1Nu44xJDw9KO_CRwpInbWJfNr5b0kdpi5ezBc4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/past-missions/index.vue")
  },
  {
    name: "offers-offer-services-create",
    path: "/offers/offer-services/create",
    meta: { ...(create_2s_vZUuhDfwj_45NZIv_KWpxn6I3Fb0qJc_2UZoYQvLoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/offers/offer-services/create.vue")
  },
  {
    name: "payment-result-success",
    path: "/payment-result/success",
    meta: { ...(indexmdLIkDMIt0NJGN_2Y4oMRksSj9H09lWlK86cw1gqyuAMeta || {}), ...{"middleware":[]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment-result/success/index.vue")
  },
  {
    name: "reward-settings-items-create",
    path: "/reward-settings/items/create",
    meta: { ...(createC_XoFCM_7APdkqK6hGBz4AKv2_45N4YGGI0J0_455fCQf_45IMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/items/create.vue")
  },
  {
    name: "social-accounts-banned",
    path: "/social/accounts/banned",
    meta: { ...(indexJuLwAWmy39XS5Ku_vgZNeq0tH3nQnRx6bWK7ACCs5LkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/banned/index.vue")
  },
  {
    name: "store-orders-me-create",
    path: "/store/orders/me/create",
    meta: { ...(indexONpuY3pRi42iuvxcbU716ZZV8JFqT55cl_45Wx86FzE70Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/index.vue")
  },
  {
    name: "store-settings-groups-create",
    path: "/store/settings/groups/create",
    meta: { ...(createaeV_sRdxBhkdvT8CNYlshXCEagACWnEeR3nmXPbfsq8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/groups/create.vue")
  },
  {
    name: "tickets-detail-for-user-id",
    path: "/tickets/detail-for-user/:id()",
    meta: { ...(_91id_9369n9Mvl5EzFQHs15rsaRQS2sY1OiclIy1ylw4uFi1tgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/tickets/detail-for-user/[id].vue")
  },
  {
    name: "whatsapp-instances-edit-id",
    path: "/whatsapp/instances/edit/:id()",
    meta: { ...(_91id_93S21oqNsOKex2bax4b6Un0Z0pvT_XPxP20hocWcVJk9oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/whatsapp/instances/edit/[id].vue")
  },
  {
    name: "admin-announcements-edit-id",
    path: "/admin/announcements/edit/:id()",
    meta: { ...(_91id_93kE3V9HdEATghuoO7Ni0rkw40WU_7zBDwh2Tsyitz3GAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/announcements/edit/[id].vue")
  },
  {
    name: "admin-blocked-links-edit-id",
    path: "/admin/blocked/links/edit/:id()",
    meta: { ...(_91id_93htBMGkzTn3mOYcGvxWOcVO0CssSUYcASuqXK76wVQOUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/blocked/links/edit/[id].vue")
  },
  {
    name: "admin-quick-answers-edit-id",
    path: "/admin/quick/answers/edit/:id()",
    meta: { ...(_91id_93D8JAcXlu1_Wl9hCMPAGCsyHuaDmc5AynpGpcXxvRt1MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/quick/answers/edit/[id].vue")
  },
  {
    name: "missions-proofs-me-id",
    path: "/missions/proofs/me/:id()",
    meta: { ...(index4iwjH5mqTfA_45HltreFpP0oZMkHoGFM0k3dwCAdWDd6sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proofs/me/[id]/index.vue")
  },
  {
    name: "payment-accounts-me-edit-id",
    path: "/payment/accounts/me/edit/:id()",
    meta: { ...(_91id_93fMRoYZ5VO9E_45L5REw4Oyqn9jl7PibxbOlQbrYmVAxUQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/me/edit/[id].vue")
  },
  {
    name: "reward-settings-oyunfor",
    path: "/reward-settings/oyunfor",
    meta: { ...(indexQYZtZqvy08CtKIgf8pHUAT7Q1ZWNgPPuf5yHOTlw4qkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/oyunfor/index.vue")
  },
  {
    name: "social-accounts-banned-create",
    path: "/social/accounts/banned/create",
    meta: { ...(createUddDF5NyM86UdaM2Z7EypLmPdmW_458JJ1IK0zSw5iuBAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/banned/create.vue")
  },
  {
    name: "store-settings-packages",
    path: "/store/settings/packages",
    meta: { ...(indexxbp3NC1mIiYdHrI6GuNxYPl1U7U_45off0QSyeODfcxCMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/index.vue")
  },
  {
    name: "store-settings-services",
    path: "/store/settings/services",
    meta: { ...(indexhtCffplvuTZQ8Q5f9Dz3_14web6_45_45FCnLCCIIrj1mW0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/services/index.vue")
  },
  {
    name: "admin-service-categories",
    path: "/admin/service/categories",
    meta: { ...(index7sWG3KDCI7q3TudsFvVhY6RBw08cuoGXMdaqOz_45yALsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/categories/index.vue")
  },
  {
    name: "mobile-announcements-edit-id",
    path: "/mobile/announcements/edit/:id()",
    meta: { ...(_91id_93OHDP06Ae2GEiLzHLdmD3gobV1cP6JJp3y74P4XWJg7UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/mobile/announcements/edit/[id].vue")
  },
  {
    name: "offers-integrated-offers",
    path: "/offers/integrated-offers",
    meta: { ...(indexFwapb4m6NkpLWWq7ihmjVVPpVYmVvpeBRJIcJL8igpsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/offers/integrated-offers/index.vue")
  },
  {
    name: "reports-user-point-ranks",
    path: "/reports/user-point-ranks",
    meta: { ...(index82iMyMIXaELwQ6spVHVwTFFcEOmgM_bFehD1ubw7IF8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reports/user-point-ranks/index.vue")
  },
  {
    name: "store-settings-packages-create",
    path: "/store/settings/packages/create",
    meta: { ...(create_45RpjoZr8F076apliFsJuYIclF71AN0ho5MG4ufRb89cMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/create.vue")
  },
  {
    name: "store-settings-services-create",
    path: "/store/settings/services/create",
    meta: { ...(createJ6oxSC5ZWFDhRTtxdfPUOxyLrs4Tn_CPx1aOWJmNMToMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/services/create.vue")
  },
  {
    name: "admin-service-categories-create",
    path: "/admin/service/categories/create",
    meta: { ...(createQ2ne_45ka_45VpNZikkKzLFy6CQbLt9DINieizXsE0JRgJcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/categories/create.vue")
  },
  {
    name: "missions-pending-approval",
    path: "/missions/pending-approval",
    meta: { ...(index_shEDOHAcDXHNj5tOXF5OyTU4LpfjmPFk2fPwF7qUNsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/pending-approval/index.vue")
  },
  {
    name: "missions-tracking-me-id",
    path: "/missions/tracking/me/:id()",
    meta: { ...(indexTofpZWXCklgH6LR39FmU3oLWQXkp_45os5MY1yz07DELsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/tracking/me/[id]/index.vue")
  },
  {
    name: "missions-user-with-proofs",
    path: "/missions/user-with-proofs",
    meta: { ...(index4tieUPv_45cn_45cVmjyH6PeD0JCSobVTZNCJZkiKhES1lUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/user-with-proofs/index.vue")
  },
  {
    name: "offers-offer-services-edit-id",
    path: "/offers/offer-services/edit/:id()",
    meta: { ...(_91id_93Ng56Zc27VxLO4lIxA4fibZEl8LzoZk5R06WGnJvZmtwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/offers/offer-services/edit/[id].vue")
  },
  {
    name: "reports-user-spend-report",
    path: "/reports/user-spend-report",
    meta: { ...(indexzSTbEdBWC7F2lt7ejZ_fHgiwaa5VK52jJi2MYjV38m0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reports/user-spend-report/index.vue")
  },
  {
    name: "reward-settings-items-edit-id",
    path: "/reward-settings/items/edit/:id()",
    meta: { ...(_91id_93yXGE5bWTsJvVuicTwnlFjZozcMZNZOnYswwJiZV8S6cMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/items/edit/[id].vue")
  },
  {
    name: "reward-requests-me-create",
    path: "/reward/requests/me/create",
    meta: { ...(indexuqRJozN5IPspdcgHNC4_D9iPn8x_45bdWwksHwSOio2ywMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/me/create/index.vue")
  },
  {
    name: "store-settings-categories",
    path: "/store/settings/categories",
    meta: { ...(indexE2RqZv1iSHfhRlEIZaeyNQ_rYp1ULr4gUxYWIORtS84Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/categories/index.vue")
  },
  {
    name: "store-settings-groups-edit-id",
    path: "/store/settings/groups/edit/:id()",
    meta: { ...(_91id_9352PwajBm2Dju5tOuguUmS1_45pbpvIYIHr3SsoDRWVlsYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/groups/edit/[id].vue")
  },
  {
    name: "me-missions-action-waiting",
    path: "/me/missions/action/waiting",
    meta: { ...(indexoBlzdxk1lmxof4srho9N44hZ1ItpHKjrh3H7Zd2e_ukMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/action/waiting/index.vue")
  },
  {
    name: "me-missions-proofs-declined-id",
    path: "/me/missions/proofs/declined/:id()",
    meta: { ...(_91id_934gTEdpceIwPlrKhgWC9oHgkVTHrbpfFPjX1kvsFUTq0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proofs/declined/[id].vue")
  },
  {
    name: "me-missions-re-upload-proof-id",
    path: "/me/missions/re-upload-proof/:id()",
    meta: { ...(_91id_93Sm0tTYxi7A7nVreWnSgCoVKbu2bqpoMlUCx5AJzLMUIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/re-upload-proof/[id].vue")
  },
  {
    name: "reward-settings-categories",
    path: "/reward-settings/categories",
    meta: { ...(indexBfXocL1F_lHVUxKdTRSITkZMqeLQftviXXircBpDN9EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/categories/index.vue")
  },
  {
    name: "social-accounts-banned-edit-id",
    path: "/social/accounts/banned/edit/:id()",
    meta: { ...(_91id_93ks4FW4_45fIRbhhJ4DGVWXxp4h75xIobNUX_S40EP8wKUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/banned/edit/[id].vue")
  },
  {
    name: "store-settings-categories-create",
    path: "/store/settings/categories/create",
    meta: { ...(createy5jc_JWL3EIICMqzAu_458ncwbazGADM1ZsoZV_45jKgTp8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/categories/create.vue")
  },
  {
    name: "me-missions-action-approved",
    path: "/me/missions/action/approved",
    meta: { ...(indexwB5cMJB5ZWws5Cg_i7TKIEkmlP80x_456DZdfpI4_45CKXsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/action/approved/index.vue")
  },
  {
    name: "me-missions-action-rejected",
    path: "/me/missions/action/rejected",
    meta: { ...(indexYvYsrmHZ0Nko45mR0rkk895y09YYCoO41hPdsYkbaM4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/action/rejected/index.vue")
  },
  {
    name: "me-missions-rejected-proofs",
    path: "/me/missions/rejected-proofs",
    meta: { ...(indexCwlR6493WAq7cB7zhdZ3DmmuaEyGzRiv4jVp0lRJMUsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/index.vue")
  },
  {
    name: "reward-settings-categories-create",
    path: "/reward-settings/categories/create",
    meta: { ...(createdDj_45et0nM9U1wrZ3aHDxhoSsldyLZn_ynejv9FiiYCYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/categories/create.vue")
  },
  {
    name: "store-settings-packages-edit-id",
    path: "/store/settings/packages/edit/:id()",
    meta: { ...(_91id_93j_45vm6SpGeVQF36cRBf_458Hw1WnEbPKL9x0IwoCGA_coAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/edit/[id].vue")
  },
  {
    name: "store-settings-services-edit-id",
    path: "/store/settings/services/edit/:id()",
    meta: { ...(_91id_939zzuia7yS3vJIFSa9PNvMGB5ZD2BxUV0QbWRqSfHbvoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/services/edit/[id].vue")
  },
  {
    name: "admin-parameter-items-code",
    path: "/admin/parameter/items-:code()",
    meta: { ...(indexE97q5SeXYfC2IHI3ykMH1WoHxUm4iOntEU3z1mfVSLIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/index.vue")
  },
  {
    name: "admin-roles-permissions-id",
    path: "/admin/roles/permissions/:id()",
    meta: { ...(indexuRgRMbuW5jzgjN6BmQv2LZRQcFuuPPynoHp_9S0qVewMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/permissions/[id]/index.vue")
  },
  {
    name: "admin-service-categories-edit-id",
    path: "/admin/service/categories/edit/:id()",
    meta: { ...(_91id_93Zn4QAXjERPyLyHfPBjItX2wYckR0stP7dRtgjowPWFMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/categories/edit/[id].vue")
  },
  {
    name: "missions-proof-pending-users",
    path: "/missions/proof-pending-users",
    meta: { ...(indexGP6ApqKYXWf7or3ArJhCkIRhEuYriYo5vJXuF2yvUIoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-users/index.vue")
  },
  {
    name: "payment-plans-payment-result",
    path: "/payment/plans/payment-result",
    meta: { ...(indexGRPb14elfeD1dFt4vKsNM_6fj1vwQuaE6ptSINNWTxwMeta || {}), ...{"middleware":[]} },
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/payment-result/index.vue")
  },
  {
    name: "reports-daily-mission-report",
    path: "/reports/daily-mission-report",
    meta: { ...(indexrri1au99HMBKFCbtSoMyhTI1kf16ci_zfWfU0pNmSrkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reports/daily-mission-report/index.vue")
  },
  {
    name: "reports-daily-payment-report",
    path: "/reports/daily-payment-report",
    meta: { ...(indexa443x2EatCUs4PLP0gkpraPDEU_45nsZ_cpIWzidXnWYgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reports/daily-payment-report/index.vue")
  },
  {
    name: "admin-parameter-items-code-create",
    path: "/admin/parameter/items-:code()/create",
    meta: { ...(createEjNGBzCrFJ3ahLJJjK2ezy3Ct6LkvpXkHtbymmyHIMgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/create.vue")
  },
  {
    name: "store-settings-categories-edit-id",
    path: "/store/settings/categories/edit/:id()",
    meta: { ...(_91id_93dwEeqsFbeqQxTaGs24GLbQq0uYvEOTWZ4ZtkWDzVYhUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/categories/edit/[id].vue")
  },
  {
    name: "information-perfect-price-logs",
    path: "/information/perfect-price-logs",
    meta: { ...(index_FC32IdwP7kIFuPnoGGey0gvFXmt1v_45PdRw_45q8cp1mAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/information/perfect-price-logs/index.vue")
  },
  {
    name: "missions-proof-decline-request",
    path: "/missions/proof-decline-request",
    meta: { ...(indexJe1wNQriTFHZGpr32qWlT4UyWlly9jJRDQ3yxkehk7sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-decline-request/index.vue")
  },
  {
    name: "missions-user-with-proofs-id",
    path: "/missions/user-with-proofs/:id()",
    meta: { ...(indexf0XI7NhYkTRVNPNM71QxpTb3pVTZNT7Ey3RGEzboDdgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/user-with-proofs/[id]/index.vue")
  },
  {
    name: "reward-settings-categories-edit-id",
    path: "/reward-settings/categories/edit/:id()",
    meta: { ...(_91id_93a29BMVJ35IX1mKhIlxLGSzjIlKHzdm3RVdsaXhFVVVoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/categories/edit/[id].vue")
  },
  {
    name: "reward-requests-me-create-id",
    path: "/reward/requests/me/create/:id()",
    meta: { ...(indexfOFYnXt6OvqOW6NtmKmrhuF_rWSZikS_45gJYeEoxhyu8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/me/create/[id]/index.vue")
  },
  {
    name: "subscriptions-pending-approval",
    path: "/subscriptions/pending-approval",
    meta: { ...(indexDQx6_459g1ezHg4_uOFCfAJIaNqVg0dk9zB5cF9vqzEMQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/subscriptions/pending-approval/index.vue")
  },
  {
    name: "missions-proof-pending-approval",
    path: "/missions/proof-pending-approval",
    meta: { ...(indexrMk0SGKAQuIDztjrL0ErIMDn7bD1fikT_c8vMnUyiacMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/index.vue")
  },
  {
    name: "admin-mission-auto-approve-rules",
    path: "/admin/mission-auto-approve-rules",
    meta: { ...(indexX6G2mQxCkKHMYcUud9LStURj4JljuIqxOqnxouLe0QsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/mission-auto-approve-rules/index.vue")
  },
  {
    name: "admin-parameter-items-code-edit-id",
    path: "/admin/parameter/items-:code()/edit/:id()",
    meta: { ...(_91id_93ALxLEdf6MDMqYxWA6ntU97aGaRn2DO7gXssYUL3cj1MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/edit/[id].vue")
  },
  {
    name: "me-missions-rejected-proofs-id",
    path: "/me/missions/rejected-proofs/:id()",
    meta: { ...(indexrSsFi4A3liEcziDVT5SR_IaEJbrr5p3oaBXyFe9P2jUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/[id]/index.vue")
  },
  {
    name: "social-accounts-verified-control",
    path: "/social/accounts/verified-control",
    meta: { ...(indexLQJxNFfCximOw6kGr__RDQI7yFnWsBj2vxXv9xdF2FcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/verified-control/index.vue")
  },
  {
    name: "admin-mission-auto-approve-rules-create",
    path: "/admin/mission-auto-approve-rules/create",
    meta: { ...(createGYAxcSfblkNAv68k5mZvf7Oh9qZJDiMbGauHnFmm_RUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/mission-auto-approve-rules/create.vue")
  },
  {
    name: "admin-service-category-rules-id",
    path: "/admin/service/category/rules/:id()",
    meta: { ...(indexs_45kKVGU3ZvM3r0fy1l7SiSc4EJmURmsA46ac0SrTeKQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/index.vue")
  },
  {
    name: "missions-proof-pending-users-id",
    path: "/missions/proof-pending-users/:id()",
    meta: { ...(index0C5wAzTv2G5NTAza5L_1sm6DTalygJ_fjQobwQ8Tm2oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-users/[id]/index.vue")
  },
  {
    name: "admin-service-category-rules-id-create",
    path: "/admin/service/category/rules/:id()/create",
    meta: { ...(createUNgKiYnhkwHMgvyy88nGmOJQd4IHztMEa1JCwFaKMdMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/create.vue")
  },
  {
    name: "me-missions-proof-pending-approval",
    path: "/me/missions/proof-pending-approval",
    meta: { ...(indexiSgk_45qEpy_45BNBEz6cmeVRwUkIQybF9ekYo_7Dag7htAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/index.vue")
  },
  {
    name: "missions-proof-pending-approval-me",
    path: "/missions/proof-pending-approval/me",
    meta: { ...(indexoMJ6_45gcmOpRoILZg15mKiD9Xhq2_p5pn2_9rYhBYOewMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/index.vue")
  },
  {
    name: "missions-proof-decline-request-id",
    path: "/missions/proof-decline-request/:id()",
    meta: { ...(indexnrfutMd_twSRBTmRxZlxmuBJqZ1J1F3VCRSqaA43a7YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-decline-request/[id]/index.vue")
  },
  {
    name: "admin-mission-auto-approve-rules-edit-id",
    path: "/admin/mission-auto-approve-rules/edit/:id()",
    meta: { ...(_91id_935IyqEWsQ8_45naH3a2jtkL_45uHGmZx3S6DViZLJ74vxMxcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/mission-auto-approve-rules/edit/[id].vue")
  },
  {
    name: "missions-proof-pending-approval-id",
    path: "/missions/proof-pending-approval/:id()",
    meta: { ...(index6q_45yZ2POD51cK6gHy9hS8smz6nxcXtxFLIiHHsUex0oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/[id]/index.vue")
  },
  {
    name: "contract-gizlilik-ve-cerez-politikasi",
    path: "/contract/gizlilik-ve-cerez-politikasi",
    meta: indexO0JbS7xewchrfkHwlr_45hpF_45_GTJslMD60KLvnzyPcMoMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/contract/gizlilik-ve-cerez-politikasi/index.vue")
  },
  {
    name: "me-missions-proof-pending-approval-id",
    path: "/me/missions/proof-pending-approval/:id()",
    meta: { ...(index2wxLhSGxxpxeVDsVogu27T5iKIBysLtwcJT2W3bp6cUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/[id]/index.vue")
  },
  {
    name: "missions-proof-pending-approval-me-id",
    path: "/missions/proof-pending-approval/me/:id()",
    meta: { ...(indexCjsTNuMAP6DRvshLJoI2KspboYNZlmuvWC4psXAFzoAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/[id]/index.vue")
  },
  {
    name: "admin-service-category-rules-id-edit-rule_id",
    path: "/admin/service/category/rules/:id()/edit/:rule_id()",
    meta: { ...(_91rule_id_93uTYr0XB8uNCKgiMYmqz3NuUvd0KmF_h_iXSgQKmWanoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/edit/[rule_id].vue")
  },
  {
    name: "store-orders-me-create-store_category_id",
    path: "/store/orders/me/create/:store_category_id()",
    meta: { ...(indexTeXaZCd9snxOt1aLtGdGZXCtCUqYrMZStiqno4rcGEwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/index.vue")
  },
  {
    name: "store-settings-packages-package_id-attributes",
    path: "/store/settings/packages/:package_id()/attributes",
    meta: { ...(index1TU6NMq73VcbOaKrehS5Vp4BSB1O692_45qi60LekgQ8cMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/index.vue")
  },
  {
    name: "store-settings-packages-package_id-attributes-create",
    path: "/store/settings/packages/:package_id()/attributes/create",
    meta: { ...(createCwTjnlk4z7DccVgse05YQpY7z4SCoho7oTDHBD3LShsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/create.vue")
  },
  {
    name: "store-settings-packages-package_id-attributes-edit-id",
    path: "/store/settings/packages/:package_id()/attributes/edit/:id()",
    meta: { ...(_91id_93quKEpk1a1AymoWv1iqfvbhlqjSSXR_45v0Z7SSpa75zVEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/edit/[id].vue")
  },
  {
    name: "store-orders-me-create-store_category_id-store_group_id",
    path: "/store/orders/me/create/:store_category_id()/:store_group_id()",
    meta: { ...(indexxdX_45dX47eHEDF_TiQpu7UJc7xhKDXBzzLHz8sO3mOrYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_group_id]/index.vue")
  },
  {
    name: "store-orders-me-create-store_category_id-store_service_id",
    path: "/store/orders/me/create/:store_category_id()/:store_service_id()",
    meta: { ...(indexOrUzLKUIorM1RVdnn8AN9MhzqBgwhXLxGagkHRyQhSkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_service_id]/index.vue")
  }
]